import React from "react";
import BackToTop from "../components/BackToTop";
import DataDisclaimerContent from "../components/DataDisclaimerContent";
import Footer from "../components/Footer";
import Hero9 from "../components/heros/Hero9";
import AppNavbar from "../components/navbar/AppNavbar";

const DataDisclaimer = () => {
  return (
    <>
      <AppNavbar classname="navbar-dark" isLogoDark={true} showItems={false} />
      <div id="home">
        <Hero9 />
      </div>
      <DataDisclaimerContent />
      <Footer />
      {/* back to top button */}
      <BackToTop />
    </>
  );
};

export default DataDisclaimer;
